import ApiHelper from "../../helpers/ApiHelper";
import GeneralHelper from "../../helpers/GeneralHelper";
import BaseService from "../BaseService";

class WatchlistService extends BaseService {

    static url = "watchlists";
    static apis = {
        getList: this.url + "/count"
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("watchlists");
    }

    getList(customerId) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({ url: WatchlistService.apis.getList, method: "GET", params: { customer_id: customerId }, authorization: true, showLoader: true })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    deleteRecord(customerId, kitId) {
        var that = this
        var data = {
            customer_id: customerId,
            kit_id: kitId
        }

        return new Promise((resolve, reject) => {
            that.axios({
                url: WatchlistService.url, method: "DELETE", data: data, authorization: true, showLoader: true,
                message: {success: GeneralHelper.buildMessage(1, "Removed from watchlist !")}
            })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

}

export default WatchlistService;